import { Component, OnInit } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { fromLonLat } from 'ol/proj';
import ImageLayer from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-olm',
  templateUrl: './olm.component.html',
  styleUrls: ['./olm.component.css']
})
export class OlmComponent implements OnInit {
  map!: Map;

  ngOnInit(): void {
    const layers: (TileLayer<OSM> | ImageLayer<ImageWMS>)[] = [
      new TileLayer({
        source: new OSM()
      }),
    ];
    if (environment.geoserverWmsUrl) {
      layers.push(
        new ImageLayer({
          source: new ImageWMS({
            url: environment.geoserverWmsUrl,
            params: {
              'LAYERS': 'your_workspace:your_layer_name',
              'TILED': true
            },
            ratio: 1,
            serverType: 'geoserver'
          })
        })
      );
    }
    this.map = new Map({
      target: 'map',
      layers,
      view: new View({
        center: fromLonLat([72.8777, 19.0760]), // Mumbai coords
        zoom: 10
      })
    });
  }
}
